import { SimpleArrowIcon } from 'assets/icons'

interface CreditScoreCardProps {
  children: JSX.Element | JSX.Element[]
  title?: string | JSX.Element
  disabled?: boolean
  rightButtonAction?: () => void
  datatestid?: string
  className?: string
}

export default ({
  children,
  rightButtonAction = null,
  disabled = false,
  title = null,
  datatestid = null,
  className = ''
}: CreditScoreCardProps) => (
  <div
    data-testid={datatestid}
    className={`flex bg-white w-full rounded-[10px] p-4 justify-center items-center shadow ${className}`}
  >
    <section className='flex flex-grow flex-col h-full'>
      {title && (
        <>
          <h4 className='text-xs text-black font-bold mb-2'>{title}</h4>
          <div className='border-t' />
        </>
      )}
      <div className='flex flex-col items-start justify-center flex-grow'>
        {children}
      </div>
    </section>
    {rightButtonAction && (
      <section className='w-[2.375rem] flex justify-end'>
        <button
          type='button'
          disabled={disabled}
          onClick={() => rightButtonAction()}
          className={`flex justify-center items-center w-6 h-6 rounded-full  ${
            disabled ? 'bg-gray-500' : 'bg-purple-900'
          }`}
        >
          <p className='sr-only'>➡</p>
          <SimpleArrowIcon stroke='#FFFFFF' />
        </button>
      </section>
    )}
  </div>
)
